import Axios, { AxiosRequestConfig } from 'axios';
import Environment, { ENV } from '../../Environment';

import { IAnalyticsData } from './Types';
import { Platform } from 'react-native';

const debug = require('debug')('tca:kit:services:AnalyticsService');

export default class AnalyticsService {
  private static get host() {
    return Environment.analyticsService;
  }

  public static sendEvent({
    type = '',
    appKey = '',
    data,
  }: {
    type: string;
    appKey: string;
    data: IAnalyticsData;
  }) {
    /**
     * There are currently no analytics host for dev and stage
     * and we do not want to mix analytics for different environments.
     * Therefore, we do not send analytics if env is not prod.
     */
    if (ENV !== 'prod') {
      debug(
        `${ENV} environment. No need to send analytics to non-prod environment. Skipping.`
      );

      return;
    }

    debug(`Sending analytics data:${JSON.stringify(data)}`);

    const url = `${this.host}/${appKey}/${type}`;
    const requestConfig: AxiosRequestConfig = {
      url,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'sap-device-os': Platform.OS,
        'sap-device-timezone-offset':
          (new Date().getTimezoneOffset() / 60) * 100,
      },
      data,
    };

    return Axios(requestConfig).then(this.onSuccess).catch(this.onFailure);
  }

  private static onSuccess() {
    debug('Sent analytic event success');
  }

  // @ts-ignore
  private static onFailure(e) {
    debug('Sent analytic event failed', e);
  }
}
